<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/part.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-8">
                  <div class="pagename">
                    <h3 class="card-title">
                      Total Hours of Mentorship Received by Mentee
                    </h3>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ mentorshipTotal }}</h2>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="excel">
                    <button
                      type="button"
                      *ngIf="exl"
                      title="XL"
                      class="btn btn-primary addbtn ml-3"
                      (click)="exportToExcel()"
                    >
                      <i class="fa fa-file-excel-o"></i>Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                datatable
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Mentee Name</th>
                    <!-- <th>Average Meeting Time</th> -->
                    <th>Duration</th>
                  </tr>
                </thead>
                <tbody *ngIf="mentorshipList?.length != 0">
                  <tr
                    *ngFor="let item of mentorshipList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ getRowNumber(i) }}</td>
                    <td>{{ item.mentee_name }}</td>
                    <td>{{ item.duration }}</td>
                  </tr>
                </tbody>
                <tbody *ngIf="mentorshipList?.length == 0">
                  <tr>
                    <td colspan="4" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
